import { useState } from 'react'
import { Loader2, LogOut } from '@/lib/icons'
import { Button } from '@/components/ui/button'
import { Modal } from '@/components/ui/modal'
import { logoutRequest } from '../auth/api'

/**
 * Sozlamalar sahifasidagi "Hisob" bo'limi — paneldan chiqish.
 *
 * Avval "Chiqish" sidebar footer'ida edi, lekin u yerda navigatsiya yonida turib tasodifan
 * bosilishi oson edi (foydalanuvchi shikoyati). Shuning uchun: (1) Sozlamalar ichiga
 * ko'chirildi, (2) tasdiq oynasi qo'shildi — oynada "Tizimda qolish" yashil va fokusli
 * (xavfsiz standart), "Chiqish" esa och kulrang/kam ajralib turadi, tasodifan bosilmasin.
 *
 * ⚠️ Faqat brauzer rejimida ma'noli (chaqiruvchi `SettingsPage` `isInsideTelegram()` bilan
 * gate qiladi): Telegram ichida sessiya cookie'si yo'q — tozalanadigan narsa yo'q.
 */
export function LogoutSection() {
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [loggingOut, setLoggingOut] = useState(false)

  const handleConfirm = () => {
    setLoggingOut(true)
    // Server bilan aloqa uzilsa ham reload qilamiz — eng yomon holatda login ekranida
    // qolamiz (keyingi so'rov sessiyani baribir qayta tekshiradi). Bu mantiq avval
    // AppShell'da edi.
    void logoutRequest().finally(() => window.location.reload())
  }

  const closeConfirm = () => {
    if (!loggingOut) setConfirmOpen(false)
  }

  return (
    <section className="flex flex-col gap-3 rounded-card border border-app-border bg-app-card p-4">
      <div>
        <h2 className="text-base font-semibold">Hisob</h2>
        <p className="mt-1 text-sm text-app-hint">
          Paneldan chiqasiz. Qayta kirish uchun Telegram orqali tasdiqlashingiz kerak bo&apos;ladi.
        </p>
      </div>
      <Button
        variant="secondary"
        className="self-start hover:bg-app-bg"
        onClick={() => setConfirmOpen(true)}
      >
        <LogOut size={16} aria-hidden="true" />
        Chiqish
      </Button>

      <Modal
        open={confirmOpen}
        onClose={closeConfirm}
        ariaLabel="Tizimdan chiqish"
        size="compact"
        zIndex={50}
      >
        <div className="flex flex-col gap-4 p-5">
          <h2 className="text-base font-semibold">Tizimdan chiqasizmi?</h2>
          <p className="text-sm text-app-hint">
            Paneldan chiqib ketasiz. Qayta kirish uchun Telegram orqali tasdiqlashingiz kerak
            bo&apos;ladi.
          </p>
          <div className="flex justify-end gap-2 pt-1">
            {/* "Tizimda qolish" — yashil, asosiy va xavfsiz tanlov. DOM'da BIRINCHI: Modal
                fokus tuzog'i birinchi bosiladigan elementga fokus beradi, shuning uchun oyna
                ochilganda Enter tasodifan tizimdan chiqarib yubormaydi. */}
            <Button variant="primary" onClick={closeConfirm} disabled={loggingOut}>
              Tizimda qolish
            </Button>
            {/* "Chiqish" — och kulrang fill (app-hint 10%), kam ajralib turadi, tasodifan
                bosilmasin uchun. Qizil (danger) EMAS: bu qaytarib bo'lmas amal emas. */}
            <Button
              variant="secondary"
              className="border-transparent bg-app-hint/10 text-app-text hover:bg-app-hint/20"
              onClick={handleConfirm}
              disabled={loggingOut}
            >
              {loggingOut ? (
                <Loader2 size={16} className="animate-spin" aria-hidden="true" />
              ) : (
                <LogOut size={16} aria-hidden="true" />
              )}
              Chiqish
            </Button>
          </div>
        </div>
      </Modal>
    </section>
  )
}
